export default {
  en: {
    id: 'exercise3',
    answers: [
      {
        title: `
                <div class="box-title">Health care market changing, plans moving beyond simple insurance to</div>
                <div>
                 - Managing medical costs<br/>
                 - Owning provider care organizations<br/>
                 - Developing, packaging, marketing, selling “healthcare products”
                </div>`,
        answer: 1,
        hasArrow: true
      },
      {
        title: `<div class="box-title">Upgrade the present systems</div>`,
        answer: 2,
        hasArrow: true
      },
      {
        title: `<div class="box-title">Take advantage of commonalities to cut costs of new systems</div>`,
        answer: 3,
        hasArrow: true
      },
      {
        title: `
                <div class="box-title">Too expensive for each State to do alone</div>
                <div>
                	- Wasteful to build 4 separate systems
                </div>`,
        answer: 4,
        hasArrow: true
      }
    ],
    image: '5b1-1.png'
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/i18n/exercise3.js